<script>
  // 잠긴 게시판 안내. 판정과 잠금 사유는 전부 서버가 준다 —
  // 여기서 board_type 으로 다시 유추하면 규칙이 두 벌이 된다.
  let {
    board = { name: '', slug: '', description: '', accessible: false, lock_reason: null },
    signed_in = false,
    work_email = null,
    candidate_domain = null,
    domain_registered = false,
    organization_name = null,
    verification_path = '/verification',
    login_path = '/login',
    boards_path = '/boards'
  } = $props()

  // 안내 문구와 다음 행동은 세 갈래다.
  //  1) 로그인 전        → 로그인
  //  2) 도메인 등록됨    → 소속 인증하면 열린다
  //  3) 도메인 미등록    → 인증해도 열리지 않는다. 등록 요청이 먼저다.
  const needsLogin = $derived(!signed_in)
  const needsVerification = $derived(
    signed_in && board.lock_reason === 'company_verification' && domain_registered
  )
  const needsDomain = $derived(
    signed_in && board.lock_reason === 'company_verification' && !domain_registered
  )
  const plainForbidden = $derived(signed_in && board.lock_reason !== 'company_verification')
</script>

<div class="max-w-xl mx-auto px-4 py-12" style="word-break: keep-all; overflow-wrap: break-word;">
  <div class="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-dark-secondary p-8">

    <div class="flex items-center gap-3 mb-6">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-amber-50 dark:bg-amber-900/20">
        <svg class="h-6 w-6 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
        </svg>
      </span>
      <div>
        <p class="text-sm text-gray-500 dark:text-dark-text-medium">잠긴 게시판</p>
        <h1 class="text-xl font-bold text-gray-900 dark:text-white">{board.name}</h1>
      </div>
    </div>

    {#if needsLogin}
      <p class="text-gray-700 dark:text-dark-text-medium leading-relaxed">
        이 게시판은 로그인한 회원에게만 열립니다.<br />
        로그인하면 소속 인증 상태에 따라 바로 이용할 수 있습니다.
      </p>
      <a href={login_path}
         class="mt-6 inline-flex items-center justify-center rounded-xl bg-primary px-5 py-3 font-medium text-white hover:opacity-90 transition-opacity">
        로그인하기
      </a>

    {:else if needsVerification}
      <p class="text-gray-700 dark:text-dark-text-medium leading-relaxed">
        소속 인증을 마치면 열립니다.<br />
        {#if organization_name}
          <span class="font-medium text-gray-900 dark:text-white">{organization_name}</span> 도메인은
          이미 등록돼 있어,
        {:else}
          회사 도메인은 이미 등록돼 있어,
        {/if}
        회사 이메일 인증만 마치면 됩니다.
      </p>
      {#if work_email}
        <p class="mt-3 text-sm text-gray-500 dark:text-dark-text-low">
          등록된 회사 이메일: {work_email}
        </p>
      {/if}
      <a href={verification_path}
         class="mt-6 inline-flex items-center justify-center rounded-xl bg-primary px-5 py-3 font-medium text-white hover:opacity-90 transition-opacity">
        소속 인증하기
      </a>

    {:else if needsDomain}
      <p class="text-gray-700 dark:text-dark-text-medium leading-relaxed">
        이 게시판은 소속 인증을 마친 회원에게만 열립니다.<br />
        다만 지금 계정의 도메인{#if candidate_domain}(<span class="font-medium">{candidate_domain}</span>){/if}은
        아직 인증기관으로 등록되지 않아, 인증을 진행해도 열리지 않습니다.
      </p>
      <p class="mt-4 rounded-xl bg-gray-50 dark:bg-dark-tertiary p-4 text-sm text-gray-600 dark:text-dark-text-medium leading-relaxed">
        회사 도메인 등록이 먼저 필요합니다.<br />
        운영진에게 도메인 등록을 요청해 주세요.
      </p>
      <a href={verification_path}
         class="mt-6 inline-flex items-center justify-center rounded-xl border border-gray-300 dark:border-gray-600 px-5 py-3 font-medium text-gray-700 dark:text-dark-text-medium hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
        회사 이메일 확인하기
      </a>

    {:else if plainForbidden}
      <p class="text-gray-700 dark:text-dark-text-medium leading-relaxed">
        이 게시판에는 접근 권한이 없습니다.<br />
        권한이 필요하면 운영진에게 문의해 주세요.
      </p>
    {/if}

    <div class="mt-8 pt-6 border-t border-gray-100 dark:border-gray-700">
      <a href={boards_path} class="text-sm text-primary hover:underline">← 게시판 목록으로</a>
    </div>
  </div>
</div>
